import React from 'react';
import SongLinks from './SongLinks';
import cover from "../assets/coverart/Tiefseetauchen.jpg"


export const Tiefseetauchen = () => {    

    return (
        <SongLinks 
        title={"Tiefseetauchen"} 
        coverArt={cover} 
        spotifyLink={"https://open.spotify.com/album/5qsX2X3DUas269i31vm2Gv"}
        spotifyPresaveLink={"https://add-it.feiyr.com/MondWild/Tiefseetauchen"}
        appleMusicLink={"https://music.apple.com/de/album/tiefseetauchen-single/6809347641"} 
        appleMusicPresaveLink={undefined}
        youtubeMusicLink={"https://music.youtube.com/watch?v=n9kSohTUclE"}
        youtubeLink={"https://www.youtube.com/watch?v=LmznPJBmApw"}
        tidalLink={"https://tidal.com/album/559078393/track/559078395"}
        amazonMusicLink={"https://www.amazon.de/music/player/albums/B0HJ214X7Z"}
        bandcampLink={"https://mondwild.bandcamp.com/track/tiefseetauchen"}
        releaseDate={"2026-10-09T00:00:00+02:00"}/>
    );
}
